import { render, staticRenderFns } from "./ChangeCompany.vue?vue&type=template&id=605205b3&scoped=true&"
import script from "./ChangeCompany.vue?vue&type=script&lang=js&"
export * from "./ChangeCompany.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCompany.vue?vue&type=style&index=0&id=605205b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605205b3",
  null
  
)

export default component.exports